import React from 'react';

interface LiveRegionProps {
  children: React.ReactNode;
  polite?: boolean;
  className?: string;
}

export default function LiveRegion({ children, polite = true, className }: LiveRegionProps) {
  return (
    <div
      role="status"
      aria-live={polite ? 'polite' : 'assertive'}
      aria-atomic="true"
      className={className}
    >
      {children}
    </div>
  );
}
